// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1NWf0","col":"CardReaderDesc_col__12gZ6","label":"CardReaderDesc_label__2Z-q4"};